import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import useTabsCarouselProduct from "../../hooks/useTabsCarouselProduct.js";
import MessageErrorMobile from "./message-error/index.js";
import * as S from "./styled.js";
import TabProductMobile from "./tab-product/index.js";
import TabTitle from "./tab-title/index.js";
const TabsCarouselProductCardMobile = ({ props  })=>{
    const { items =[] , title ='' , link , config ={} , getTabsProducts , defaultImage  } = props ?? {};
    const { selectedTab , dataTab =[] , tabLoaded , onClickTap  } = useTabsCarouselProduct(items, config, getTabsProducts);
    const finalTabs = useMemo(()=>dataTab.map((item, index)=>{
            if (item.error?.error) return {
                index,
                label: /*#__PURE__*/ _jsx(TabTitle, {
                    title: item.title
                }),
                element: /*#__PURE__*/ _jsx(MessageErrorMobile, {
                    error: item.error,
                    literals: config.literals
                })
            };
            return {
                index,
                label: /*#__PURE__*/ _jsx(TabTitle, {
                    title: item.title
                }),
                element: /*#__PURE__*/ _jsx(TabProductMobile, {
                    tab: item,
                    config: {
                        ...config,
                        ...item?.config
                    },
                    isLoading: !tabLoaded[index],
                    defaultImage: defaultImage
                })
            };
        }), [
        dataTab,
        config,
        tabLoaded,
        defaultImage
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": "TabsCarouselProductCardMobile",
        children: [
            /*#__PURE__*/ _jsx(S.TitleWrapperMobile, {
                title: title,
                link: link
            }),
            finalTabs.length > 1 ? /*#__PURE__*/ _jsx(S.TabsProductWrapperMobile, {
                selectedTab: selectedTab,
                onClick: onClickTap,
                tabs: finalTabs
            }) : items.length ? /*#__PURE__*/ _jsx(TabProductMobile, {
                tab: items[0],
                config: config,
                defaultImage: defaultImage
            }) : null
        ]
    });
};
export default TabsCarouselProductCardMobile;

//# sourceMappingURL=index.js.map